import React from "react";
import PropTypes from "prop-types";
import style from "../../stylesheets/FilterOption.module.scss";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";

const ColorFilterOption = ({
  filterOption,
  facetName,
  isMobile,
  isCurrentFilter,
  mobileHandleFilterClick,
  handleFilterClick,
}) => {
  // selected filter
  const selectedFilterClass = isCurrentFilter
    ? style.selectedFilter
    : style.unselectedFilter;
  const selectedColorFilter = isCurrentFilter ? style.selectedColorFilter : "";

  const handleClick = () => {
    filterOption.facet_name = facetName;

    if (isMobile) {
      mobileHandleFilterClick(filterOption);
    } else {
      handleFilterClick({ filter: filterOption });
    }
  };

  let colorHexCode = {};
  let colorHexCodeBefore = null;
  let colorHexCodeAfter = null;

  if (filterOption.metadata.hex.length === 1) {
    const backgroundColor = `#${filterOption.metadata.hex[0]}`;
    colorHexCode = { backgroundColor };
  }

  if (filterOption.metadata.hex.length === 2) {
    colorHexCodeBefore = (
      <div
        className={style.colorHexCodeBefore}
        style={{
          backgroundColor: `#${filterOption.metadata.hex[0]}`,
        }}
      />
    );

    colorHexCodeAfter = (
      <div
        className={style.colorHexCodeAfter}
        style={{
          backgroundColor: `#${filterOption.metadata.hex[1]}`,
        }}
      />
    );
  }

  const colorFilterBox = isMobile
    ? mobileStyle.colorFilterBox
    : style.colorFilterBox;
  const colorMultiSelectIcon = isMobile
    ? mobileStyle.colorMultiSelectIcon
    : style.colorMultiSelectIcon;

  return (
    <div
      className={`${colorFilterBox} ${selectedColorFilter}`}
      onClick={handleClick}
    >
      {colorHexCodeBefore}
      <li value={filterOption.id} style={colorHexCode}>
        <span
          className={`${selectedFilterClass}
            ${colorMultiSelectIcon}`}
          title={filterOption.name}
        />
      </li>
      {colorHexCodeAfter}
    </div>
  );
};

ColorFilterOption.propTypes = {
  filterOption: PropTypes.object.isRequired,
  facetName: PropTypes.string.isRequired,
  isCurrentFilter: PropTypes.bool.isRequired,
  handleFilterClick: PropTypes.func.isRequired,
  mobileHandleFilterClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default ColorFilterOption;
